// Desktop header navigation: split each bilingual label into accessible,
// duplicated characters so it can roll upward one character at a time.
(function () {
  function splitCharacters(text) {
    if (typeof Intl !== 'undefined' && Intl.Segmenter) {
      return Array.from(new Intl.Segmenter(undefined, { granularity: 'grapheme' }).segment(text), function (part) {
        return part.segment;
      });
    }

    return Array.from(text);
  }

  function enhanceLine(line) {
    if (line.dataset.navRollReady === 'true' && line.querySelector('.umikaze-nav-roll')) return;

    var text = line.textContent.trim();
    if (!text) return;

    var accessibleText = document.createElement('span');
    accessibleText.className = 'visually-hidden';
    accessibleText.textContent = text;

    var visualText = document.createElement('span');
    visualText.className = 'umikaze-nav-roll';
    visualText.setAttribute('aria-hidden', 'true');

    splitCharacters(text).forEach(function (character, index) {
      var characterWindow = document.createElement('span');
      characterWindow.className = 'umikaze-nav-roll__character';

      var characterTrack = document.createElement('span');
      characterTrack.className = 'umikaze-nav-roll__track';
      characterTrack.style.setProperty('--nav-roll-index', index);

      var visibleCharacter = document.createElement('span');
      visibleCharacter.textContent = character === ' ' ? '\u00a0' : character;

      var incomingCharacter = visibleCharacter.cloneNode(true);
      incomingCharacter.setAttribute('aria-hidden', 'true');

      characterTrack.append(visibleCharacter, incomingCharacter);
      characterWindow.append(characterTrack);
      visualText.append(characterWindow);
    });

    line.replaceChildren(accessibleText, visualText);
    line.dataset.navRollReady = 'true';
  }

  function init(root) {
    root.querySelectorAll('.menu-list__link-title .menu-item-title__line').forEach(enhanceLine);
  }

  function initDocument() {
    init(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDocument);
  } else {
    initDocument();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  // The theme may replace header markup shortly after initial page load.
  // Re-enhance only newly inserted navigation lines, wherever they appear.
  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      var changedLine = mutation.target.closest && mutation.target.closest('.menu-list__link-title .menu-item-title__line');
      if (changedLine) enhanceLine(changedLine);

      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== Node.ELEMENT_NODE) return;

        if (node.matches('.menu-list__link-title .menu-item-title__line')) {
          enhanceLine(node);
        }

        node.querySelectorAll('.menu-list__link-title .menu-item-title__line').forEach(enhanceLine);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
})();
